module.exports = __webpack_public_path__ + "static/media/Electric.8e130595.svg";